// extracted by mini-css-extract-plugin
export default {"googleButton":"styles_googleButton__WhiYY","googleMark":"styles_googleMark__xv1Zi"};